import React from 'react';
import { Helmet } from 'react-helmet';

function Finish_Seo() {
    return (
        <div>
            <Helmet>
                <title>Complete onboarding process in less than a minute with IDScan | FinestPay</title>
                <meta name="description" content="Easy and quick KYC confirms that now you are ready to make your first transfer. Get started today." />
                <meta property="og:title" content="Complete onboarding process in less than a minute with IDScan | FinestPay" />
                <meta property="og:description" content="Easy and quick KYC confirms that now you are ready to make your first transfer. Get started today." />
                <meta property="og:image" content="https://finestpay.co.uk/assets/img/FinestPay-icon.png" /> {/* Replace with actual image URL */}
                <meta property="og:url" content={window.location.href} />
                <meta property="og:type" content="website" />
                <link rel="canonical" href="https://finestpay.co.uk/finish"/>
            </Helmet>
        </div>
    )
}

export default Finish_Seo
